import { hideLoading, showLoading } from '@/utils/loading'
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BACKEND_BASE_URL
const sendRequest = async (api, data, headers, params, ...rest) => {
    const { method, url } = api

    const defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }

    const axiosConfig = {
        method,
        url: `${baseUrl}/${url}`,
        data: data || {},
        headers: {
            ...defaultHeaders,
            ...(headers || {})
        },
        params: params || {},
        ...rest
    }

    // If data is FormData, don't set Content-Type (browser will set it with boundary)
    if (data instanceof FormData) {
        delete axiosConfig.headers['Content-Type']
    }

    try {
        showLoading()
        const response = await axios(axiosConfig)

        return response.data
    } catch (error) {
        console.error(`Api error: ${error.message}`)
        throw error
    } finally {
        hideLoading()
    }
}

export default sendRequest
